function parseData(data) {
  if (!data) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  
    const paymentDetails =  ({inputParam, metaData}) =>
      api.paymentDetails(inputParam, metaData)
        .then(parseData)
        .catch((error) => {
          const data = {
            body:error.body,
            statusCode: error.statusCode
          }
          return parseData(data);
        })

    const consentUpdate = ({ inputParam, metaData }) =>
      api.consentUpdate(inputParam, metaData)
        .then(parseData)
        .catch((error) => {
          const data = {
            body:error.body,
            statusCode: error.statusCode
          }
          return parseData(data);
      })

      const confirmedPayment = ({ inputParam, metaData }) =>
      api.confirmedPayment(inputParam, metaData)
        .then(parseData)
        .catch((error) => {
          const data = {
            body:error.body,
            statusCode: error.statusCode
          }
          return parseData(data);
      })

      const updatePayment=({inputParam, metaData})=>
      api.updatePayment(inputParam, metaData)
      .then(parseData)
      .catch((error)=>{
        const data = {
          body:error.body,
          statusCode: error.statusCode
        }
        return parseData(data);
      })

  return {
    paymentDetails,
    consentUpdate,
    confirmedPayment,
    updatePayment
  }
    
}

module.exports = serviceFactory;